import { Tag } from '../../../general/model';
import { MessagesInterface } from '../../../general/model';

export type TagShape = {
  isOpen: boolean;
  isInitialized: boolean;
  isApplying: boolean;
  tagsLoaded: Tag[];
  tagsSelected: Tag[];
  searchText: string;
  recursive: boolean;
};

export type TagOption = {
  label: string;
  value: number;
};

export const Messages: MessagesInterface = {
  initModalError: () => ({
    title: `Server request error`,
    message: `Tags have not been received`,
  }),
  createTagsError: (names: string[]) => ({
    title: `Server request error`,
    message: `The following tags have not been created: ${names.join(', ')}`,
  }),
  patchNodeTagsError: (nodeNames: string[]) => ({
    title: `Server request error`,
    message: `Tags have not been updated for the following nodes: ${nodeNames.join(', ')}`,
  }),
  patchNodeTagsSuccess: () => ({
    title: `Tags have been updated`,
  }),
};
